import React, {Component} from 'react';
import {Nav,NavItem,NavLink} from 'reactstrap';
import {Link} from 'react-router-dom';
import './user.css';

class User extends Component {
    
    render() {
        return(
            <div>
                <div className="App-header">
                </div>
            <div>
                <Nav>
                    <NavItem>
                      <NavLink href="/users"><Link to="/users">Users Home</Link></NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="/usersblog"><Link to="/usersblog">User Blog</Link></NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="/usersstore"><Link to="/usersstore">User store</Link></NavLink>
                    </NavItem>
                </Nav>
            </div>
            <div>
                This is the users main page
            </div>
            </div>
        )
    }
}

export default User;

